import React, { useCallback, useEffect, useState } from "react";
import { Button, Spin, Modal } from "antd";
import { getRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { toast } from "react-toastify";
import Preview from "../Preview/preview";
import "../table/viewMicrosite.scss";

export default function ViewMicrosite({
  ClearRow,
  orgId,
  HideViewMicrositeHandler,
  showTagsHandler,
  closeModal,
}) {
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(true);
  const [microsites, setMicrosites] = useState(null);
  const [previewSelector, setPreviewSelector] = useState(false);
  const [allMicrosites, setAllMicrosites] = useState();

  const getMicrositesData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getRequest(
        userServiceApi.getMicrositesByOrganization(orgId)
      );
      // console.log("res", response)
      if (response.data.length > 1) {
        // console.log("here")
        setPreviewSelector(true);
        setAllMicrosites(response.data);
        // setPreview(true);
        // setMicrosites(response.data[0].id);
      } else {
        // console.log("here")
        // setPreview(true)
        setMicrosites(response.data[0].id);

        // if (preview) {
        //   setMicrosites(response.data[0].id);
        // }
      }

      setLoading(false);
    } catch (error) {
      toast.error(error.error);
    }
  }, [orgId]);

  useEffect(() => {
    getMicrositesData();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [orgId, getMicrositesData]);

  const RemoveMicrosite = () => {
    setMicrosites(null);
    closeModal();
  };

  const handleCancel = () => {
    closeModal();
  };
  // console.log("preview selector", previewSelector);
  if (loading || loader) {
    // return (
    //   <div className="data-loader">
    //     <Spin className="spin" tip="Loading" size="large" />
    //   </div>
    // );
  }
  // else {
  return (
    <>
      {loading || loader ? (
        <div className="approve-container">
          <div className="data-loader">
            <Spin className="spin" tip="Loading" size="large" />
          </div>
        </div>
      ) : (
        <div className="approve-container">
          {microsites && (
            <>
              <Preview
                micrositeId={microsites}
                RemoveMicrosite={RemoveMicrosite}
              />
            </>
          )}
          {/* {console.log(allMicrosites)} */}
          {previewSelector && allMicrosites && (
            <>
              <Modal
                open={true}
                footer={null}
                // onCancel={() => setPreviewSelector(false)}
                onCancel={handleCancel}
                width="500px"
                className="preview-modal-root"
              >
                {/* {allMicrosites && ( */}
                <div>
                  <h3>Sites</h3>
                  {allMicrosites.map((microsite) => {
                    return (
                      <>
                        {microsite ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              margin: "10px",
                              marginTop: "20px",
                            }}
                          >
                            <p>{microsite.name}</p>
                            <Button
                              className={
                                microsite.isPublished
                                  ? "enabled-button"
                                  : "disabled-button"
                              } // Apply different classes based on isPublished
                              onClick={() => {
                                setMicrosites(microsite?.id);
                              }}
                              disabled={!microsite.isPublished} // Disable the button when isPublished is not true
                            >
                              Open site
                            </Button>
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    );
                  })}
                </div>
                {/* )} */}
              </Modal>
            </>
          )}
        </div>
      )}
      {/* </Modal> */}
    </>
  );
}

// }
